import type React from "react";
import { Button } from "./ui/button";
import { AlertCircle } from "lucide-react";

interface ErrorFallbackProps {
  error: Error;
  resetError: () => void;
}

const ErrorFallback: React.FC<ErrorFallbackProps> = ({ error, resetError }) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full">
        <div className="flex flex-col items-center text-center">
          <AlertCircle className="h-16 w-16 text-red-500 mb-4" />
          <h1 className="text-2xl font-bold text-gray-800 mb-2">
            Ops! Algo deu errado
          </h1>
          <p className="text-gray-600 mb-6">{error.message}</p>
          <Button
            onClick={resetError}
            variant="default"
            className="bg-red-500 hover:bg-red-600 text-white font-semibold py-2 px-4 rounded-full transition duration-300 ease-in-out transform hover:scale-105"
          >
            Tentar novamente
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ErrorFallback;
